<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('bill.text_177')}}</div>
    <div slot="body">
      <!-- <div>
        <div class="title">{{$t('bill.text_178')}}</div>
        <p>{{ ruleDesc || $t('bill.text_163') }}</p>
        <div class="title">{{$t('bill.text_178')}}</div>
        <p>{{ JSON.stringify(selectItem.problem || '{}') }}</p>
        <div class="title">{{$t('bill.text_180')}}</div>
        <p class="suggest">{{ selectItem.suggest || $t('bill.text_163') }}</p>
      </div> -->
      <dialog-selected-tips :name="$t('bill.suggest')" class="mt-3" :count="params.data.length" :unit="$t('bill.suggest_unit')" :action="$t('bill.text_177')" />
      <dialog-table v-if="params.columns && params.columns.length" :data="params.data" :columns="columns" />
      <a-form-model
        ref="form"
        :model="fd"
        v-bind="formItemLayout">
        <a-form-model-item :label="$t('bill.text_180')">
          {{ $t('suggestsySuggestion')[selectItem.type] || $t('bill.text_163') }}
        </a-form-model-item>
        <a-form-model-item :label="$t('bill.process_methods')">
          <a-radio-group v-model="fd.processMethod">
            <a-radio-button v-for="v in newProcessMethods" :key="v.key" :value="v.key">
              {{ v.value }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { getRuleTypeName, getRuleDesc } from '@Bill/utils'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { hasPermission } from '@/utils/auth'
import { getProblemTableColumn } from '../utils/columns'
import { actionMap, PROCESSING_METHODS } from '../constants'

export default {
  name: 'SuggestsAlertDeleteDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      fd: {
        processMethod: 'delete',
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
    }
  },
  computed: {
    columns () {
      let showFields = []
      if (this.params.ruleScope === 'cost') {
        showFields = ['res_name', 'type', 'amount', 'problem']
      } else {
        showFields = ['res_name', 'type', 'problem']
      }

      return this.params.columns.filter((item) => { return showFields.includes(item.field) }).concat([getProblemTableColumn()])
    },
    selectItem () {
      return this.params.data[0]
    },
    action () {
      const action = this.selectItem.action
      return actionMap[action] || this.$t('bill.text_167')
    },
    ruleDesc () {
      const ruleName = getRuleTypeName(this.selectItem.type)
      const ruleDesc = getRuleDesc(this.selectItem.type, this.selectItem.monitor_config).strategy || this.$t('bill.text_163')
      return `${ruleName}(${ruleDesc})`
    },
    isOnlyIgnore () {
      // const onlyIgnoreRules = ['adjust oss acl', 'adjust secgroup rule', 'down size server config', 'up size server config', '', '']
      const onlyIgnoreRules = [
        'SCALING_SERVER',
        'DOWN_SIZE',
        'UP_SIZE',
        'TIMING_OPEN_SERVER',
        'SECGROUPRULEINSERVER_ALLIN',
        'OSS_SEC_ACL',
        'CLOUDACCOUNT_AMOUNT_DAILY',
        'CLOUDACCOUNT_AMOUNT_MONTH',
        'EXPIRE_SERVER_SKU',
        'TIMING_SERVER',
        'upgrade_prepaid',
      ]
      const rule = this.selectItem.type
      return onlyIgnoreRules.includes(rule)
    },
    newProcessMethods () {
      const type = this.selectItem.res_type
      if (this.isOnlyIgnore || !hasPermission({ key: 'suggestsysalerts_delete' })) {
        return [PROCESSING_METHODS[1]]
      }
      if (type === 'server' && this.$isScopedPolicyMenuHidden('vminstance_hidden_menus.server_perform_delete')) {
        return [PROCESSING_METHODS[1]]
      }
      return PROCESSING_METHODS
    },
  },
  beforeCreate () {
    this.$store.dispatch('scopedPolicy/get', {
      category: ['vminstance_hidden_menus'],
    })
  },
  created () {
    this.fd.processMethod = this.newProcessMethods[0].key
  },
  methods: {
    doDelete (data) {
      return this.params.onManager('delete', {
        id: this.params.data[0].id,
        managerArgs: {
          data,
        },
      })
    },
    doIgnore () {
      return this.params.onManager('performAction', {
        id: this.params.data[0].id,
        managerArgs: {
          action: 'ignore',
          data: {
            scope: this.$store.getters.scope,
          },
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        this.loading = true
        if (this.fd.processMethod === 'delete') {
          await this.doDelete()
        } else if (this.fd.processMethod === 'ignore') {
          await this.doIgnore()
        }
        this.loading = false
        this.cancelDialog()
        if (this.params.vm && this.params.vm.destroySidePages) {
          this.params.vm.destroySidePage(this.params.vm.windowId)
        }
        this.params.success && this.params.success()
        this.$message.success(this.$t('bill.text_59'))
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
<style lang="less" scoped>
.title {
  font-size: 12px;
  color: rgb(170, 170, 170);
}
.suggest {
  color: rgb(215, 173, 70);
}
</style>
